import {MI} from "../init";
import {main_phaser} from "../../framework/src/engine/madnes/MadnesApp";
import {madnes_get_json} from "../../framework/src/engine/madnes/madnes";

/**
 * @constructor
 * @param {MadnesGroup=} group
 * @returns {FreeSpinOption}
 */
export default function FreeSpinOption(group) {

    /** @type {MadnesGroup|undefined|null} */
    this._group = group;

    /** @type {MadnesObject} */
    this._paperParent;

    /** @type {MadnesObject} */
    this.sprite;

    /** @type {MadnesObject} */
    this.spriteBg;

    /** @type {MadnesObject} */
    this.button;

    this._buttonEnabled = false;
    this._buttonLocked = false;

    /**
     * @public
     * @type {boolean}
     */
    this.choosed = false;

    /** @type {string} */
    this.typeName;

    this._scaleTo = 1;

    this._flyToX = 1280 / 2;
    this._flyToY = 720 / 2;

    /** @type {MadnesTween} */
    this._animFlyIn;
    /** @type {MadnesTween} */
    this._animScaleIn;
    /** @type {MadnesTween} */
    this._animAlphaIn;
    /** @type {MadnesTween} */
    this._animRotateIn;
};

FreeSpinOption.types = {
    5: "shuffling",
    9: "changing",
    7: "random"
};

FreeSpinOption.getNumByIndex = function(num) {
    switch(num) {
        case 0: return 5;
        case 1: return 9;
        case 2: return 7;
    }
};

// FreeSpinOption.numberTypes = { //request data to server
// 	"random": 0,
// 	"shuffling": 1,
// 	"changing": 2
//
// };

//FreeSpinOption.getTypes = function() {
//	return FreeSpinOption.types.slice(0);
//	//return shuffleArray(FreeSpinOption.types).slice(0);
//};

/**
 * @returns {Number}
 */
FreeSpinOption.prototype.getTypeNumber = function() {
    return FreeSpinOption.numberTypes[this.typeName];
};

/**
 * @returns {MadnesObject}
 */
FreeSpinOption.prototype.getSprite = function() {
    return this.sprite;
};

/**
 * @param {number} x
 * @param {number} y
 * @returns {FreeSpinOption}
 */
FreeSpinOption.prototype.create = function(x, y, num = null) {

    this.sprite = MI.addImg(x, y, null)
        .setAnchor(0.5, 0.5);//.setVisible(false).setScale(0, 0).setAlpha(0);

    this._paperFront = MI.addImg(0, 0, "papers_atlas").setAnchor(0.5, 0.5);
    this._paperFront.setVisible(false);
    this._paperFront.setAlpha(0);

    if(num != null) {
        this._paperFront.setFrameName("paper_" + FreeSpinOption.types[num]);
    }

    this.sprite.addChild(this._paperFront);

    this._paperBack = MI.addImg(0, 0, "paper_random_back").setAnchor(0.5, 0.5);
    this.sprite.addChild(this._paperBack);

    this.button = MI.addImg(-204 / 2, 180 - 70 / 2, "fs_buttons")
        .setAnchor(0, 0).setFrameName("btn_choose_disabled");

    var onClick = function () {

        if (!this._buttonEnabled || this._buttonLocked) {
            return;
        }

        this._buttonLocked = true;

        this.button.setFrameName("btn_choose_pressed");

    }.bind(this);

    var clickUp = function () {

        if (!this._buttonEnabled) {
            return;
        }

        this.button.setFrameName("btn_choose_basic");
        this._onChoose && this._onChoose.call(this);

    }.bind(this);

    this.button.setHandCursor(true);
    this._paperBack.setHandCursor(true);

    this.button.onInputDown(onClick);
    this._paperBack.onInputDown(onClick);

    this.button.onInputUp(clickUp);
    this._paperBack.onInputUp(clickUp);

    this.sprite.addChild(this.button);
    this.button.setVisible(false);

    this.sprite.setVisible(false).setScale(0, 0).setAlpha(0);
    this._group && this._group.add(this.sprite);

    var btn = madnes_get_json("infotext")["buttons"]["bonus_select"];
    var styleBtn = {};
    styleBtn["font"] = btn["fontSize"] + "px " + btn["font"];
    styleBtn["fill"] = btn["color"];
    styleBtn["align"] = btn["align"];

    var buttonDesc = MI.addText(btn["position"][0], btn["position"][1], btn["content"], styleBtn); //.setAnchor(0, 0);
    this.button.addChild(buttonDesc);
    //buttonDesc.setPos(-200, -50);


    return this;
};

FreeSpinOption.prototype.createPaper = function(num, exposed) {

    this.typeName = FreeSpinOption.types[num];

    var textHead = madnes_get_json("infotext")["texts"]["bonus"][this.typeName + "_head"];
    var textHeadStyles = {};
    textHeadStyles["font"] = textHead["fontSize"] + "px " + textHead["font"];
    textHeadStyles["fill"] = textHead["color"];
    textHeadStyles["align"] = textHead["align"];

    var textHeadObj = MI.addText(textHead["position"][0], textHead["position"][1], textHead['content'], textHeadStyles); //.setAnchor(0, 0);
    this._paperFront.addChild(textHeadObj);

    var text = madnes_get_json("infotext")["texts"]["bonus"][this.typeName];
    var stylesTxt = {};
    stylesTxt["font"] = text["fontSize"] + "px " + text["font"];
    stylesTxt["fill"] = text["color"];
    stylesTxt["align"] = text["align"];

    var desc = MI.addText(text["position"][0], text["position"][1], text['content'], stylesTxt); //.setAnchor(0, 0);
    this._paperFront.addChild(desc);

    var descStr = madnes_get_json("infotext")["texts"]["bonus"]["strength_desc"];
    var descCert = madnes_get_json("infotext")["texts"]["bonus"]["certanity_desc"];
    var descQuant = madnes_get_json("infotext")["texts"]["bonus"]["quantity_desc"];
    var styles = {};
    styles["font"] = descStr["fontSize"] + "px " + descStr["font"];
    styles["fill"] = descStr["color"];

    //console.log(styles, descStr["position"][0], descStr["position"][1]);

    var descStrength = MI.addText(descStr["position"][0], descStr["position"][1], descStr['content'], styles).setAnchor(1, 0);
    this._paperFront.addChild(descStrength);

    var descCetr = MI.addText(descCert["position"][0], descCert["position"][1], descCert['content'], styles).setAnchor(1, 0);
    this._paperFront.addChild(descCetr);

    var descQunat = MI.addText(descQuant["position"][0], descQuant["position"][1], descQuant['content'], styles).setAnchor(1, 0);
    this._paperFront.addChild(descQunat);

    if(exposed) {
        this._paperFront.setVisible(true);
        this._paperFront.setAlpha(1);
        this._paperBack.setVisible(false);
    }
};

/**
 * @param {number} x
 * @param {number} y
 * @returns {FreeSpinOption}
 */
FreeSpinOption.prototype.setFlyTo = function(x, y) {
    this._flyToX = x;
    this._flyToY = y;

    return this;
};

FreeSpinOption.prototype.setScaleTo = function(num) {
    this._scaleTo = num;
};

FreeSpinOption.prototype._createBg = function() {
    this.spriteBg = MI.addImg(this.sprite.getPosX(), this.sprite.getPosY(), "paper_random_back")
        .setAnchor(0.5, 0.5).setBlend("ADD").setVisible(false);

    this.sprite.addChild(this.spriteBg);
};

//FreeSpinOption.prototype.getToPos = function() {
//
//	var toObj = { 'x': wi / 2, 'y': he / 2 - 40 };
//
//	if(this.typeName === "shuffling") {
//		toObj = { 'x': wi / 2 - 350 / 2  - 200, 'y': he / 2 - 40 };
//	} else if (this.typeName === "random") {
//		toObj = { 'x': wi / 2 + 350 / 2  + 200, 'y': he / 2 - 40 };
//	}
//
//	return toObj;
//};

/**
 * @param {number} delay
 * @param {number} rotateCount
 * @param {number=} duration
 * @returns {Promise}
 */
FreeSpinOption.prototype.play = function(delay, rotateCount, duration) {

    var _self = this;

    var dur = typeof duration !== 'undefined' ? duration * 1 : 2400;

    return new Promise(function(res) {

        if(delay) {
            setTimeout(function() {
                _self._play(_self._flyToX, _self._flyToY, dur, rotateCount, res);
            }, delay);
        } else {
            _self._play(_self._flyToX, _self._flyToY, dur, rotateCount, res);
        }
    });
};

/**
 * @param {number} flyToX
 * @param {number} flyToY
 * @param {number} duration
 * @param {number} rotateCount
 * @param {Function=} callback
 */
FreeSpinOption.prototype._play = function(flyToX, flyToY, duration, rotateCount, callback) {

    this._paperAnimFlyIn(duration, flyToX, flyToY, callback);
    this._paperAnimScaleIn(duration);
    this._paperAnimAlphaIn(duration);
    this._paperAnimRotateIn(duration / 2, rotateCount); //.then();
};

FreeSpinOption.prototype.chooseAnim = function() {
    this._createBg();
    return this._paperBgScale();
};

FreeSpinOption.prototype.expose = function() {

    this._paperFront.setFrameName("paper_" + this.typeName); //.setAlpha(1);

    var isWebgl = main_phaser.renderType === Phaser.WEBGL;

    if(!this.choosed && isWebgl) {
        this._paperFront.setFilter("Gray");
        this.button.setFilter("Gray");
    }

    return new Promise(function(res) {

        this._paperFront.setVisible(true);

        if(isWebgl) {
            MI.addTween().to(this._paperFront, { alpha: 1 }, { duration: 1000 });
        } else {
            MI.addTween().to(this._paperFront, { alpha: this.choosed ? 1 : 0.64 }, {
                duration: 1000
            });
        }

        MI.addTween().to(this._paperBack, { alpha: 0 }, {
            duration: 1000,
            callback: function() {
                res();
            }
        });
    }.bind(this));


};

/**
 * @returns {Promise}
 */
FreeSpinOption.prototype.close = function() {
    return new Promise(function(res) {
        if(this.choosed) {
            this._paperAnimRotateOut(1000);
            this._paperAnimFlyOut().then(res);
            this._paperAnimScaleOut();
            this._paperAnimAlphaOut();
        } else {
            this._paperAnimAlphaOut().then(res);
        }
    }.bind(this));
};

FreeSpinOption.prototype.destroy = function() {
    this._paperFront.destroy();
    this._paperBack.destroy();
    this.spriteBg && this.spriteBg.destroy();
    this.sprite.destroy();

    this._animFlyIn && this._animFlyIn.destroy();
    this._animScaleIn && this._animScaleIn.destroy();
    this._animAlphaIn && this._animAlphaIn.destroy();
    this._animRotateIn && this._animRotateIn.destroy();
};

FreeSpinOption.prototype.enableButton = function() {
    this.button.setFrameName("btn_choose_basic");
    this._buttonEnabled = true;
};

FreeSpinOption.prototype.disableButton = function() {
    this.button.setFrameName("btn_choose_basic");
    this._buttonEnabled = false;
};

FreeSpinOption.prototype._paperAnimFlyIn = function(duration, toX, toY, cb) {

    //var wi = MI.getWi();
    //var he = MI.getHe();

    this.sprite.setVisible(true);

    this._animFlyIn = MI.addTween().to(this.sprite, { 'x': toX, 'y': toY }, {
        'duration': duration,
        'callback': cb
    });
};

FreeSpinOption.prototype._paperAnimFlyOut = function() {

    return new Promise(function(res) {

        var x = MI.getWi() / 2;
        var y = MI.getHe();

        MI.addTween().to(this.sprite, { 'x': x, 'y': y + 200 }, {
            'duration': 1800,
            'callback': function() {
                //this.sprite.destroy();
                res();
            }//.bind(this)
        });

    }.bind(this));
};

/**
 * @param {number} duration
 * @param {number} count
 * @returns {Promise}
 */
FreeSpinOption.prototype._paperAnimRotateIn = function(duration, count) {

    return new Promise(function(res) {
        this._animRotateIn = MI.addTween().to(this.sprite, { 'angle': 360 }, {
            'duration': duration,
            'count': count,
            'callback': res
        });
    }.bind(this));
};

FreeSpinOption.prototype._paperAnimRotateOut = function(duration) {

    //return new Promise(function(res) {

    //this.sprite.setAngle(-360);

    MI.addTween().from(this.sprite, { 'angle': 359 }, {
        'duration': duration
        //'count': 1,
        //'callback': res
    });
    //}.bind(this));
};

FreeSpinOption.prototype._paperAnimScaleIn = function(duration) {
    this.sprite.setScale(0, 0);
    this._animScaleIn = MI.addTween().to(this.sprite, { 'x': this._scaleTo, 'y': this._scaleTo }, {
        'scale': true,
        'duration': duration
    });
};

FreeSpinOption.prototype._paperAnimScaleOut = function() {
    //this.sprite.setScale(1, 1);
    MI.addTween().to(this.sprite, { 'x': 0, 'y': 0 }, {
        'scale': true,
        'duration': 1800
    });
};

FreeSpinOption.prototype._paperAnimAlphaIn = function(duration) {
    this.sprite.setAlpha(0);
    this._animAlphaIn = MI.addTween().to(this.sprite, { 'alpha': 1 }, {
        'duration': duration * 0.466
    });
};

/**
 * @returns {Promise}
 */
FreeSpinOption.prototype._paperAnimAlphaOut = function() {
    return new Promise(function(res) {
        MI.addTween().to(this.sprite, { 'alpha': 0 }, {
            'duration': 1800,
            'callback': res
        });
    }.bind(this));
};

/**
 * @returns {Promise}
 */
FreeSpinOption.prototype._paperBgScale = function() {
    return new Promise(function(res) {

        this.spriteBg.setPos(0, 0, true);
        this.spriteBg.setVisible(true);
        this.spriteBg.setAlpha(1);
        this.spriteBg.setScale(1, 1);

        MI.addTween().to(this.spriteBg, { 'alpha': 0 }, {
            'duration': 600
        });

        MI.addTween().to(this.spriteBg, { 'x': 1.3, 'y': 1.3 }, {
            'scale': true,
            'duration': 600,
            'callback': res
        });


    }.bind(this));
};

/*FreeSpinOption.prototype._fadeOut = function() {
	this._paperAnimAlphaOut();
},*/

/**
 * @param {Function} func
 * @returns {FreeSpinOption}
 */
FreeSpinOption.prototype.onChoose = function(func) {
    this._onChoose = func;
    return this;
};

FreeSpinOption.prototype.choose = function() {
    this._onChoose();
};

FreeSpinOption.prototype.blink = function(state) {

    if(state % 2 === 0) {
        this.button.setFrameName("btn_choose_pressed");
    } else {
        this.button.setFrameName("btn_choose_basic");
    }
};

FreeSpinOption.prototype.levitationStart = function(delay) {
    return;
    /*MI.addTween().to(this.sprite, { 'y': this.sprite.getPosY() + 14 }, {
        'duration': 3000,
        'delay': delay,
        'yoyo': true,
        'count': -1,
        'tween': MadnesTween.getEasing("sinusoidal_in_out")
    });*/
};